// @flow
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { createSimpleAPIMiddleware } from '@localytics/redux-simple-api-middleware/lib/simpleAPI';
import reducers from './reducers';
import log from './util/ErrorUtils';

const errorLoggingMiddleware = (/* store */) => next => action => {
  const { type = '' } = action;
  if (type.indexOf('_FAILURE') >= 0) {
    log(new Error(type), { ...action });
  }
  return next(action);
};

const configure = () => {
  let middleware = applyMiddleware(
    thunk,
    errorLoggingMiddleware,
    createSimpleAPIMiddleware()
  );

  /* eslint-disable no-underscore-dangle */
  if (window.__REDUX_DEVTOOLS_EXTENSION__) {
    middleware = compose(middleware, window.__REDUX_DEVTOOLS_EXTENSION__());
  }

  const store = createStore(reducers, middleware);

  return store;
};

export default configure();



// WEBPACK FOOTER //
// ./src/store.js